import { trpc } from '@/data-loaders';

export const useAdminAreas = (options?: { enabled?: boolean }) => {
  return trpc.listAdminAreas.useQuery(undefined, {
    retry: false,
    enabled: options?.enabled ?? true,
  });
};
